import * as React from 'react';

export default class Blank extends React.PureComponent {
    render() {
        return (
            <div className="container" />
        );
    }
}